module.exports = __webpack_public_path__ + "static/media/image-not-found.5945d9ca.png";